/*
    CHARACTER
*/
//------------------------------------------------------------
// INSTANCE VARS
//------------------------------------------------------------

import Faker from 'faker';

//------------------------------------------------------------
// CHARACTER CLASS
//------------------------------------------------------------

export default class Character {
    constructor(options = {}) {

        const DEFAULTS = {
            id: Faker.random.uuid(),
            level: Faker.random.number({min:0, max:30}),
            firstName: Faker.name.firstName(),
            lastName: Faker.name.lastName(),
            email: Faker.internet.email(),
            birthdate: Faker.date.between('1960-01-01', '1986-01-01'),
            country: Faker.address.country(),
            title: Faker.name.title(),
            jobTitle: Faker.name.jobTitle(),
            jobType: Faker.name.jobType(),
            jobArea: Faker.name.jobArea(),
            lifeStatus: 'Alive',
            phone: Faker.phone.phoneNumber(),
            photo: Faker.image.avatar(),
            ssn: Faker.random.number({min:11111111, max:99999999}),

            ICU: {
                uin: Faker.random.number({min:11111111, max:99999999}),
                screenName: Faker.internet.userName(),
                status: 'offline', //Faker.random.arrayElement(['online', 'away', 'na', 'invisible', 'do-not-disturb', 'offline', 'free-for-chat']),
                textColor: Faker.internet.color(),
                textBackgroundColor: Faker.internet.color(),
                info: 'lorem ipsum dolor asit amet',
                chatScript: null, // personal chat script - basic dialogue
                chatHistory: 'something.txt'
            }
        }

        // const uid = Math.floor(100000 + Math.random() * 900000);
        // console.log(uid)

        Object.assign(this.data = {}, DEFAULTS, options);
        Object.assign(this.data.ICU = {}, DEFAULTS.ICU, options.ICU);
        return this.data;
    }
}